import store from "@/store";
import { getAuth } from "firebase/auth";

export async function userHasAuth(to, from, next) {
  try {
    const fire = getAuth();
    const userFirebase = fire.currentUser;
    const user = await store.getters["User/user"];
    const token = user.token;

    if (!userFirebase) {
      throw Error("user not logged firebase");
    }

    if (!user) {
      throw Error("user not set in bd");
    }

    if (!token) {
      throw Error("token not found");
    }

    next();
  } catch (error) {
    next({
      name: "Login",
    });
  }
}
